import axios from 'axios';

const getAllDrivers = () => axios.get(`/nlp/all`);

const getDriver = () => axios.get(`/nlp`);

const updateDriver = id => axios.put(`/nlp`, { id });

const updateSemanticDriver = id => axios.put(`/semantic-search`, { id });

const getNlpSettings = () => axios.get(`/nlp/ubinlp2`);

const updateNlpSettings = settings => axios.put(`/nlp/ubinlp2`, settings);

export {
  getAllDrivers,
  getDriver,
  updateDriver,
  updateSemanticDriver,
  getNlpSettings,
  updateNlpSettings
};
